module.exports = __webpack_public_path__ + "files/b993494cb0eef10307b5b6db8494e1eb.png";